import React from "react";
import { Col, Row } from "antd";
import style from "./DropDownCourseItem.module.scss";
import { CourseListItem } from "../../../../../service/exam";

export default function DropDownCourseItem({
    courseNo,
    courseSeq,
    courseName
}: CourseListItem) {
    return (
        <Row title={`${courseName} ${courseNo} ${courseSeq}`}>
            <Col span={10} className={style.item}>
                课程名：{courseName}
            </Col>
            <Col span={8} className={style.item}>
                编号：{courseNo}
            </Col>
            <Col span={6} className={style.item}>
                序号：{courseSeq}
            </Col>
        </Row>
    );
}
